import React ,{ Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Button, Form, Icon, Popup, Accordion } from 'semantic-ui-react';
import { InputField, Dropdown } from 'react-semantic-redux-form';

class SearchForm extends Component {

  constructor() {
    super();

    this.state = {
      showAdvanced: false,
    };
  }

  handleAccordionClick = () => {
    this.setState({
      showAdvanced: !this.state.showAdvanced,
    });
  }

  render() {
    const { handleSubmit, tags = [], categories = [], onDownloadClick } = this.props;
    const { showAdvanced } = this.state;

    const tagOptions = tags.filter( t => !t.startsWith('Affix:') && !t.startsWith('Notoriety:') ).map( t => { return {
      key: t,
      value: t,
      text: t,
    }});

    const affixOptions = tags.filter( t => t.startsWith('Affix:') ).map( t => { return {
      key: t,
      value: t,
      text: t,
    }});

    const notorietyOptions = tags.filter( t => t.startsWith('Notoriety:') ).map( t => { return {
      key: t,
      value: t,
      text: t,
    }});

    const categoryOptions = categories.map( c => { return {
      key: c,
      value: c,
      text: c,
    }});

    return (
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Field width={10}>
            <label>
              Name or Description&nbsp;
              <Popup trigger={<Icon circular name="info" color='grey' size='small' />} content="You can surround your search with quotes to perfom an exact search" />
            </label>
            <Field name="text" component={InputField} type="text" />
          </Form.Field>
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>
              Categories&nbsp;
              <Popup trigger={<Icon circular name="info" color='grey' size='small' />} content="Specify multiple categories to search for items from both.  For example, 'Armor' and 'Weapon' will show both armor and weapons." />
            </label>
            <Field name="categories" component={Dropdown} multiple search selection options={categoryOptions}/>
          </Form.Field>
          <Form.Field>
            <label>
              Tags&nbsp;
              <Popup trigger={<Icon circular name="info" color='grey' size='small' />} content="Specify multiple tags to narrow your search.  For example, 'Chest' and 'Plate' will narrow your results to plate items that are slotable on the chest." />
            </label>
            <Field name="tags" component={Dropdown} multiple search selection options={tagOptions}/>
          </Form.Field>
        </Form.Group>
        <Accordion>
          <Accordion.Title active={showAdvanced} onClick={this.handleAccordionClick}>
            <Icon name='dropdown' />Advanced Options
          </Accordion.Title>
          <Accordion.Content active={showAdvanced}>
            <Form.Group>
              <Form.Field>
                <label>Minimum Level</label>
                <Field name="minimumLevel" component={InputField} type="text" />
              </Form.Field>
              <Form.Field>
                <label>Maximum Level</label>
                <Field name="maximumLevel" component={InputField} type="text" />
              </Form.Field>
              <Form.Field>
                <label>Minimum iLevel</label>
                <Field name="minimumiLevel" component={InputField} type="text" />
              </Form.Field>
              <Form.Field>
                <label>Maximum iLevel</label>
                <Field name="maximumiLevel" component={InputField} type="text" />
              </Form.Field>
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>
                  Notoriety
                </label>
                <Field name="notoriety" component={Dropdown} multiple search selection options={notorietyOptions}/>
              </Form.Field>
              <Form.Field>
                <label>
                  Affixes
                </label>
                <Field name="affix" component={Dropdown} multiple search selection options={affixOptions}/>
              </Form.Field>
            </Form.Group>
          </Accordion.Content>
        </Accordion>
        <Form.Field>
          <Button content='Search' icon='search' labelPosition='right' primary type='submit'/>
          <Button icon='download' onClick={onDownloadClick} type='button' title="Download CSV"/>
        </Form.Field>
      </Form>
    )
  }
}

SearchForm = reduxForm({
  // a unique name for the form
  form: 'item_search'
})(SearchForm);

// You have to connect() to any reducers that you wish to connect to yourself
SearchForm = connect(
  state => ({
    initialValues: state.itemSearch.parameters
  }),
)(SearchForm)

export default SearchForm;


// WEBPACK FOOTER //
// ./src/items/search/SearchForm.jsx